import React, { useState } from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Timeline, TimelineItem } from 'vertical-timeline-component-for-react';

import './style.css';

const History = ({ histories }) => {
  const { t } = useTranslation();
  if (histories.length === 0) return <></>;

  const MoreInfo=({
    status,info
  })=>{
    //info = JSON.parse(info);

    const [hidden, setHidden] = useState(true);

    let infos = {
      awaiting_arts:(info.length>0?<>
      <Button onClick={()=>setHidden(!hidden)} className="seeMore">
          Ver {hidden?'+':'-'}
      </Button>
       
      <div className={"areaMoreInfos"+(hidden?" areaMoreInfosHidden":'')}>
        {info.map((a,k)=>{
          return <div key={k} className="areaMoreInfo">
            <div md='auto' className="moreInfoCard  align-middle" style={{
              fontSize: 'x-large'
            }}>{k+1}</div>
            {a.histories?a.histories.map((b,k2)=>{
              // var d = new Date(b.date),
              // month = '' + (d.getMonth() + 1),
              // day = '' + d.getDate(),
              // year = d.getFullYear();

              // if (month.length < 2) month = '0' + month;
              // if (day.length < 2) day = '0' + day;
              const [year, month, day] = b.date.substr(0,10).split("-"); 
              return <div key={k2} md='auto' className={
                "moreInfoCard"+
                (a.histories.length===k2+1?' moreInfoCardEnd':'')
              }>
                <div><b className="b">Usuário</b>: {b.user ? `${b.user.firstname} ${b.user.lastname}` : "--"}</div>
                <div><b className="b">Status</b>: {t(`statuses:${b.status.name}`)}</div>
                <div>{[day, month, year].join('/')}</div>
              </div>
            }):''}
          </div>
        })}
      </div></>:'')
    };
    return infos[status.name];
  };
  
  return (
    <Row className="my-5">
      <Col>
        <Card.Body className="p-2" border="none">
          <hr />
          <Row>
            <Col>
              <h5>{t('title:change history')}</h5>
            </Col>
          </Row>
          <Row>
            <Timeline>
              {histories.map((history, k) => {
                // var d = new Date(history.created_at),
                //   month = '' + (d.getMonth() + 1),
                //   day = '' + d.getDate(),
                //   year = d.getFullYear();

                // if (month.length < 2) month = '0' + month;
                // if (day.length < 2) day = '0' + day;

                const [year, month, day] = history.created_at.substr(0,10).split("-"); 
                return (<>
                  <TimelineItem
                    className="history-render-mobile"
                    title={''}
                    dateText={[day, month, year].join('/')}
                    key={k}
                    icon={<i className="fas fa-bars" />}
                    iconColor="#757575"
                    buttons={<i />}
                    container="card"
                    style={{
                      borderRadius: 13,
                      fontSize: 13,
                      minWidth: 300,
                    }}
                    cardHeaderStyle={{
                      backgroundColor: '#F57722',
                      color: '#503331',
                      fontWeight: 'bold',
                    }}
                  >
                    <div key={k}>
                      <b>{t('label:user')}:</b>{' '}
                      {history.user ? `${history.user.firstname} ${history.user.lastname}` : '--'}
                      <br />
                      <b>
                        {t('label:status')}:{' '}
                        {t(`statuses:${history.status.name}`)}
                      </b>
                      <br />
                      {!!history.comment ? (
                        <>
                          <b>{t('label:comment')}:</b> {history.comment}
                        </>
                      ) : null}
                    </div>
                    {
                      history.more_info?(
                        <MoreInfo status={history.status} info={history.info_obj}/>
                      ):'' 
                    }
                    <div></div>
                  </TimelineItem>
                </>);
              })}
            </Timeline>
          </Row>
        </Card.Body>
      </Col>
    </Row>
  );
};

export default History;
